import { AwsRum } from "aws-rum-web";

let awsRum = null;

// NOTE:
// We intentionally filter out third‑party JS errors (reCAPTCHA/Segment/GTM/etc.)
// at the plugin level, so they are not sent to CloudWatch RUM.

export function initAwsRum() {
  try {
    // CRA sets NODE_ENV at build time: "development" | "test" | "production"
    const isProd = process.env.NODE_ENV === "production";
    if (!isProd) return null;
    // Production-only + explicit toggle

    const shouldIgnoreJsError = (evt) => {
      try {
        // ErrorEvent
        if (evt && typeof evt === "object" && "message" in evt) {
          const message = String(evt.message || "");
          const filename = String(evt.filename || "");
          const lineno = Number(evt.lineno || 0);

          // iOS/WebKit cross-origin errors often get redacted into:
          // message="Script error.", filename="", lineno=0, colno=0
          if (message === "Script error." && (!filename || lineno === 0)) {
            return true;
          }

          // If filename/url exists and is not same-origin, treat as third-party noise.
          if (filename.startsWith("http")) {
            const origin = window?.location?.origin || "";
            if (origin && !filename.startsWith(origin)) return true;
          }

          const fileLower = filename.toLowerCase();
          const msgLower = message.toLowerCase();
          if (
            fileLower.includes("google.com/recaptcha") ||
            fileLower.includes("recaptcha") ||
            fileLower.includes("cdn.segment.com") ||
            fileLower.includes("googletagmanager.com") ||
            fileLower.includes("connect.facebook.net") ||
            msgLower.includes("recaptcha") ||
            msgLower.includes("private-token")
          ) {
            return true;
          }
          return false;
        }

        // PromiseRejectionEvent
        if (evt && typeof evt === "object" && "reason" in evt) {
          const reason = evt.reason;
          const text =
            String(reason?.message || reason?.toString?.() || "") +
            " " +
            String(reason?.stack || "");
          const lower = text.toLowerCase();
          if (
            lower.includes("recaptcha") ||
            lower.includes("cdn.segment.com") ||
            lower.includes("googletagmanager") ||
            lower.includes("connect.facebook.net")
          ) {
            return true;
          }
        }

        return false;
      } catch (e) {
        return false;
      }
    };

    const config = {
        sessionSampleRate: 1 ,
        endpoint: "https://dataplane.rum.us-east-2.amazonaws.com" ,
        telemetries: [
          "performance",
          ["errors", { ignore: shouldIgnoreJsError }],
          "http",
        ] ,
        allowCookies: true ,
        enableXRay: false ,
        signing: false // If you have a public resource policy and wish to send unsigned requests please set this to false
    };

    awsRum = new AwsRum("d5376596-0596-455c-af31-8d0856b2ee0e", "1.0.0", "us-east-2", config);
    return awsRum;
  } catch (e) {
    return null;
  }
}

export function getAwsRum() {
  return awsRum;
}
